// The day-grouped lines of sign-in history — shared by Settings → Security → Sign-ins and
// Profile → "Where you're signed in", so the two look the same.
import React from 'react';
import Flag from './Flag';
import { ICON_STYLES, dayHeadingParts, timeSpan } from '../../lib/securityWords';

export default function HistoryLines({ days, today, showIp = false }) {
  if (!days || days.length === 0) {
    return <p className="text-sm text-muted-foreground py-4">Nothing here yet.</p>;
  }
  return (
    <div>
      {days.map((day) => {
        // Rob, 25/10/2026: the heading says the DATE, and stands out — "YESTERDAY" in small
        // grey capitals was easy to read straight past, and never said which day it was.
        const { lead, date } = dayHeadingParts(day.date, today);
        return (
        <div key={day.date}>
          <p className="text-[13px] font-semibold bg-secondary rounded-md px-2.5 py-1 mt-4 mb-1"
             data-testid="security-day-heading">
            {lead ? <>{lead}<span className="font-normal text-muted-foreground"> · {date}</span></> : date}
          </p>
          {day.lines.map((ln) => {
            const icon = ICON_STYLES[ln.icon] || ICON_STYLES.ok;
            return (
              <div key={ln.id} className="flex gap-3 items-start py-2.5 border-t border-border first:border-t-0"
                   data-testid="security-line">
                <div className={`w-7 h-7 rounded-lg flex items-center justify-center text-sm flex-shrink-0 ${icon.cls}`}>
                  {icon.char}
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium">{ln.title}</p>
                  <p className="text-xs text-muted-foreground flex flex-wrap items-center gap-x-1.5">
                    {ln.detail && <span>{ln.detail}</span>}
                    {ln.country && <>{ln.detail && <span>·</span>}<Flag country={ln.country} /></>}
                    {showIp && ln.ip_address && <><span>·</span><span>IP {ln.ip_address}</span></>}
                  </p>
                </div>
                <span className="text-xs text-muted-foreground whitespace-nowrap">
                  {timeSpan(ln.first_at, ln.at)}
                </span>
              </div>
            );
          })}
        </div>
        );
      })}
    </div>
  );
}
